const WORDS = ["Fine wine", "Craft beer", "Single malts", "Chilled till late", "Click & collect", "Pay in store", "Snacks & essentials", "Ice always in"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`font-display px-8 text-5xl md:text-7xl ${i % 2 ? "italic text-outline" : "text-white"}`}>{w}</span>
        <span className="h-3 w-3 rotate-45 bg-[#FFC93C]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="guna-marquee" className="overflow-hidden bg-[#D62828] py-8">
    <div className="marquee-track">
      <Row />
      <Row hidden />
    </div>
  </section>
);
